import { COMPOUNDS } from '../compounds';

export const SUZUKI_CONDITION_GROUPS = [
  // CHEMSPACE_CONDITIONS
  {
    solvent: COMPOUNDS.DIGLYME_DMSO_WATER,
    catalyst: COMPOUNDS.PDDPPFCL2,
    base: COMPOUNDS.SODIUM_CARBONATE,
  },
  // SPHOS_G3_CONDITIONS
  {
    solvent: COMPOUNDS.DMSO_WATER,
    catalyst: COMPOUNDS.SPHOS_G3,
    base: COMPOUNDS.POTASSIUM_CARBONATE,
  },
  // SPHOS_G3_CONDITIONS_2
  {
    solvent: COMPOUNDS.DIGLYME_DMSO_WATER,
    catalyst: COMPOUNDS.SPHOS_G3,
    base: COMPOUNDS.POTASSIUM_CARBONATE,
  },
  // MORDALPHOS_CONDITIONS
  {
    solvent: COMPOUNDS.NBUOH_DMSO_WATER,
    catalyst: COMPOUNDS.MORDALPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
  },
  // SANOFI_2_CONDITIONS
  {
    solvent: COMPOUNDS.DMSO_WATER,
    catalyst: COMPOUNDS.PDDPPFCL2,
    base: COMPOUNDS.POTASSIUM_CARBONATE,
  },
  // SANOFI_3_CONDITIONS
  {
    solvent: COMPOUNDS.DMSO_WATER,
    catalyst: COMPOUNDS.PDDPPFCL2,
    base: COMPOUNDS.TEA,
  },
  // SANOFI_4_CONDITIONS
  {
    solvent: COMPOUNDS.DMSO_WATER,
    catalyst: COMPOUNDS.PDDPPFCL2,
    base: COMPOUNDS.TBUOK,
  },
  // SANOFI_5_CONDITIONS
  {
    solvent: COMPOUNDS.NBUOH_DMSO_WATER,
    catalyst: COMPOUNDS.PDDPPFCL2,
    base: COMPOUNDS.POTASSIUM_CARBONATE,
  },
  // SANOFI_6_CONDITIONS
  {
    solvent: COMPOUNDS.DMSO_WATER,
    catalyst: COMPOUNDS.XPHOS_G3,
    base: COMPOUNDS.POTASSIUM_CARBONATE,
  },
  // SANOFI_7_CONDITIONS
  {
    solvent: COMPOUNDS.DMSO_WATER,
    catalyst: COMPOUNDS.PDDPPFCL2,
    base: COMPOUNDS.POTASSIUM_PHOSPHATE,
  },
];
